<template>
  <transition v-bind="$attrs" :name="type" :mode="mode">
    <slot />
  </transition>
</template>

<!-- eslint-disable vue/block-lang -->
<script>
/* eslint-disable vue/component-api-style */
import { ANIMATION_TYPES } from '@/lib/enums'

export default {
  name: 'AnimationWrap',
  props: {
    type: {
      type: String,
      required: true,
      validator: function (value) {
        return Object.values(ANIMATION_TYPES).indexOf(value) !== -1
      },
    },
    mode: {
      type: [String, null],
      default: null,
      validator: function (value) {
        return ['out-in', 'in-out', null].includes(value)
      },
    },
  },
}
</script>

<style scoped lang="scss">
@use '@/styles/system/_animation.scss';

// Fade
.fade-enter-active,
.fade-leave-active {
  transition: opacity animation.$timing_250 animation.$ease_standard;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

// Quick Fade
.quick_fade {
  &-enter-active,
  &-leave-active {
    transition: opacity animation.$timing_150 animation.$ease_standard;
  }
  &-enter-from,
  &-leave-to {
    opacity: 0;
  }
}

// Fade Translate
.fade_translate-enter-active,
.fade_translate-leave-active {
  transition:
    opacity animation.$timing_250 animation.$ease_standard,
    transform animation.$timing_250 animation.$ease_standard;
}

.fade_translate-enter-from,
.fade_translate-leave-to {
  opacity: 0;
  transform: translateY(animation.$translate_distance);
}

// Image Fade
.image_fade-enter-active,
.image_fade-leave-active {
  transition: opacity animation.$timing_1500 animation.$ease_standard;
}

.image_fade-enter-from,
.image_fade-leave-to {
  opacity: 0;
}

// Fade Translate Left
.fade_translate_left-enter-active,
.fade_translate_left-leave-active {
  transition:
    opacity animation.$timing_250 animation.$ease_standard,
    transform animation.$timing_250 animation.$ease_standard;
}

.fade_translate_left-enter-from,
.fade_translate_left-leave-to {
  opacity: 0;
  transform: translateX(calc(animation.$translate_distance * -1));
}

// Fade Translate Right
.fade_translate_right-enter-active,
.fade_translate_right-leave-active {
  transition:
    opacity animation.$timing_250 animation.$ease_standard,
    transform animation.$timing_250 animation.$ease_standard;
}
.fade_translate_right-enter-from,
.fade_translate_right-leave-to {
  opacity: 0;
  transform: translateX(calc(animation.$translate_distance));
}

// Translate Left

.translate_left-enter-active,
.translate_left-leave-active {
  transition: transform animation.$timing_150 animation.$ease_standard;
}
.translate_left-leave-to {
  transform: translateX(calc(animation.$translate_distance_card_width * -1));
}

.translate_left-enter-from {
  transform: translateX(calc(animation.$translate_distance_card_width * 1));
}

// Translate Right
.translate_right-enter-active,
.translate_right-leave-active {
  transition: transform animation.$timing_150 animation.$ease_standard;
}
.translate_right-leave-to {
  transform: translateX(calc(animation.$translate_distance_card_width * 1));
}

.translate_right-enter-from {
  transform: translateX(calc(animation.$translate_distance_card_width * -1));
}
</style>
